import { HttpClientConfig } from '../../../useHttpClientConfig'
import { Page, User } from '../types'
import { service } from './service'

type UserGetManyRequest = {
  email?: string[]
  gid?: string[]
  id?: string[]
}

const ApiPathname = {
  LIST: '/api/v1/users',
  ME: '/api/v1/users/me',
} as const

const makeGetUsers =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: UserGetManyRequest): Promise<Page<User>> => {
    const { data } = await service(baseUrl).get<Page<User>>(ApiPathname.LIST, {
      ...config,
      params: {
        id: filters.id?.join(',') || undefined,
        email: filters.email?.join(',') || undefined,
        gid: filters.gid?.join(',') || undefined,
      },
    })

    return data
  }

const makeGetMe = (baseUrl: string, config: HttpClientConfig) => async (): Promise<User> => {
  const { data } = await service(baseUrl).get<User>(ApiPathname.ME, config)

  return data
}

export { makeGetUsers, makeGetMe }
export type { UserGetManyRequest }
